import { render, staticRenderFns } from "./NewParticolare.vue?vue&type=template&id=6e9124c4&"
import script from "./NewParticolare.vue?vue&type=script&lang=js&"
export * from "./NewParticolare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports